import { connect } from 'react-redux';
import Const from '@app/config/const';
import Timer from './timer';

type Params = {
  callType: 'chat' | 'voip_chat',
  events?: {
    onStarted?: () => void,
    onEnded?: () => void
  },
}

const getPropsForChat = (appState: any, params: Params): object => {
  const {
    chat: {
      paidDuration,
      freeDuration, state, buyerDurationCounterDirection
    }
  } = appState;
  return {
    ...params,
    paidDuration,
    freeDuration,
    buyerDurationCounterDirection,
    state: state === Const.chatStates.started ? 'started' : 'inital'
  };
};

const getPropsForVoice = (appState: any, params: Params): object => {
  const {
    voipChat: {
      voipState,
      conversationOption
    }
  } = appState;

  if (!conversationOption) {
    return {
      ...params,
      state: 'initial'
    };
  }

  const {
    paidDuration,
    freeSetupSeconds,
    buyerDurationCounterDirection
  } = conversationOption;

  return {
    ...params,
    paidDuration,
    freeDuration: freeSetupSeconds,
    state: voipState === Const.voipChatStates.finishing ? 'finishing' : 'started',
    buyerDurationCounterDirection
  };
};

const mapStateToProps = (appState: any, params: Params) => (params.callType === 'chat' ? getPropsForChat(appState, params) : getPropsForVoice(appState, params));

export default connect(mapStateToProps)(Timer);
